export function getDateTimeFormat(date) {
  const d = new Date(date)
  const timeStr = d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
  const dateStr = d.toLocaleDateString("en-GB")
  return `${timeStr}, ${dateStr}`
}

export default {
  convertStringToComponentAcceptingFormat(date_string) {
    // "2020-12-14 13:20:00";
    if (!date_string) {
      return ""
    }
    const date = new Date(date_string)
    let fullString = ""
    fullString += `${date.getFullYear()}-`
    fullString += `${date.getMonth() + 1}-`
    fullString += `${date.getDate()} `
    fullString += `${date.getHours()}:`
    fullString += `${date.getMinutes()}:`
    fullString += date.getSeconds()

    return fullString
  },
}
